// Libs
import writeXlsxFile from "write-excel-file";

// Services
import { getSchedule } from "../../../utils/services/schedule";

// Utils
import {
  formatData,
  formatDateTime,
} from "../../../utils/helpers/files/formatDate";

// Busca todos os registros paginados e exporta para arquivo .xlsx
export async function createXlsx({ id, limit, countData, setFinishExport }) {
  const schema = [
    {
      column: "Id",
      type: String,
      value: (schedule) => schedule.id,
    },
    {
      column: "Titulo",
      type: String,
      value: (schedule) => schedule.title,
    },
    {
      column: "Descricao",
      type: String,
      value: (schedule) => schedule.description,
    },
    {
      column: "DataDaProgramacao",
      type: String,
      value: (schedule) => formatData(schedule.startDate, "/"),
    },
    {
      column: "HoraInicio",
      type: String,
      value: (schedule) => schedule.startHour,
    },
    {
      column: "HoraFim",
      type: String,
      value: (schedule) => schedule.endHour,
    },
    {
      column: "Imagem1",
      type: String,
      value: (schedule) => schedule.picture,
    },
    {
      column: "Imagem2",
      type: String,
      value: (schedule) => schedule.picture2,
    },
    {
      column: "Imagem3",
      type: String,
      value: (schedule) => schedule.picture3,
    },
    {
      column: "Imagem4",
      type: String,
      value: (schedule) => schedule.picture4,
    },
    {
      column: "Imagem5",
      type: String,
      value: (schedule) => schedule.picture5,
    },
    {
      column: "TipoOuLocalDaProgramacao",
      type: String,
      value: (schedule) => schedule.typeOrLocation,
    },
    {
      column: "CorDaProgramacao",
      type: String,
      value: (schedule) => schedule.color,
    },

    {
      column: "ID Palestrantes",
      type: String,
      value: (schedule) => schedule.palestrantes?.map((e) => e.id).join(", ") ?? "",
    },
    {
      column: "Nome Palestrantes",
      type: String,
      value: (schedule) => schedule.palestrantes?.map((e) => e.name).join(", ") ?? "",
    },

    {
      column: "Grupos/IDs",
      type: String,
      value: (schedule) => schedule.groups?.map((e) => e.grupoId).join(", ") ?? "",
    },
    {
      column: "Grupos/Descrição",
      type: String,
      value: (schedule) => schedule.groups?.map((e) => e.grupo.name).join(", ") ?? "",
    },
    {
      column: "Data e Hora da Criação",
      type: String,
      value: (schedule) => formatDateTime(schedule.createdAt, "/"),
    },
    {
      column: "Data e Hora da Atualização",
      type: String,
      value: (schedule) => formatDateTime(schedule.updatedAt, "/"),
    },
  ];

  const responses = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getSchedule({
      id,
      offset: i,
      limit,
      search: "",
    });
    responses.push(request);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = responses.map((e) => e.agenda.data).flat();
  if (allDataInSingleArray.length > 0) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "Agenda.xlsx",
    });
  }
}
